import { render, staticRenderFns } from "./AttachDetachItemDetails.vue?vue&type=template&id=4ba10292&"
import script from "./AttachDetachItemDetails.vue?vue&type=script&lang=js&"
export * from "./AttachDetachItemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports